export function buildRistaQrOrderLabel({ orderType, tableNumber } = {}) {
  const normalizedOrderType = orderType === "takeaway" ? "takeaway" : "dine-in";
  const normalizedTableNumber = String(tableNumber || "").trim();

  if (normalizedOrderType === "takeaway") {
    return normalizedTableNumber ? `QR Table ${normalizedTableNumber}` : "QR Takeaway";
  }

  return normalizedTableNumber ? `QR Table ${normalizedTableNumber}` : "";
}
